import { createLanguageUrl } from '../../../../CreateLanguageUrl';
import { CurrentUserResource } from '../../../../CurrentUser/Types';
import { findLink } from '../../../../LinkyLinky';

export function supportMenu(user: CurrentUserResource) {
  return findLink('support', user.links).andThen((link) =>
    createLanguageUrl(link.href, user.payload.preferredLanguage),
  );
}
